import EscalateCaseModal from './EscalateCaseModal'

export default EscalateCaseModal
